import { useState, useEffect } from 'react'
import {
  StyleTabComponent,
  StyleTabItem,
  StyleTabRow,
  StyleTabWrapper,
} from './style'
import { cardStyle, StyleCardTitle } from '@components/styles'

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { Card, Typography } from '@components'

export interface TabItem {
  key: string
  label: string
  render: React.ReactNode
}

export interface TabProps {
  items: TabItem[]
  activeTab?: string
  onChange?: (tab: string) => void
  hasBg?: boolean
  title?: string
}

const Tab = ({ items, activeTab, onChange, hasBg, title }: TabProps) => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()
  const tab = searchParams.get('tab') || activeTab
  const [activeKey, setActiveKey] = useState(tab)

  useEffect(() => {
    setActiveKey(tab)
  }, [tab])

  const handleTabChange = (key: string) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('tab', key)

    setActiveKey(key)
    onChange?.(key)

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      state: location.state,
    })
  }

  const activeComponent = items?.find((item) => item.key === activeKey)

  return (
    <StyleTabWrapper>
      {!!hasBg ? (
        <Card customStyle={cardStyle} bg="primary50">
          {!!title && <StyleCardTitle>{title}</StyleCardTitle>}
          <StyleTabRow>
            {items.map((item: TabItem) => (
              <StyleTabItem
                key={item.key}
                activeBg="primary"
                activeTc="white"
                inActiveBg="transparent"
                inActiveTc="primary"
                noBorder
                isActive={item.key === activeKey}
                onClick={() => handleTabChange(item.key)}
              >
                <Typography
                  variant="p"
                  content={item.label}
                  weigth={400}
                  size={14}
                  lineHeight={20}
                />
              </StyleTabItem>
            ))}
          </StyleTabRow>
        </Card>
      ) : (
        <StyleTabRow>
          {items.map((item: TabItem) => (
            <StyleTabItem
              key={item.key}
              isActive={item.key === activeKey}
              onClick={() => handleTabChange(item.key)}
            >
              <Typography
                variant="p"
                content={item.label}
                weigth={400}
                size={14}
                lineHeight={20}
              />
            </StyleTabItem>
          ))}
        </StyleTabRow>
      )}

      <StyleTabComponent>{activeComponent?.render}</StyleTabComponent>
    </StyleTabWrapper>
  )
}

export default Tab
